import type { ButtonProps } from 'antd';
import { Button, Divider } from 'antd';
import React from 'react';

import { BUTTON_KEY } from '../actionButtonPresets';

import styles from './InventoryActions.module.scss';

export type ActionButton = ButtonProps & {
  key: BUTTON_KEY;
  label: string;
  onClick: () => void;
  node?: React.ReactNode;
};

export type InventoryActionsProps = {
  buttons: ActionButton[];
  className?: string;
};

export const InventoryActions: React.FC<InventoryActionsProps> = ({
  buttons,
  className = '',
}) => {
  const hasMultipleButtons = buttons.length > 1;

  const renderButton = (button: ActionButton) => (
    <Button
      key={button.key}
      type={button.type || 'default'}
      onClick={button.onClick}
      disabled={button.disabled}
      loading={button.loading}
      danger={button.danger}
      icon={button.icon}
      className={button.className}
    >
      {button.label}
    </Button>
  );

  return (
    <div className={`${styles.inventoryActions} ${className}`.trim()}>
      {buttons.map((button) => {
        if (button.node) {
          return (
            <React.Fragment key={button.key}>{button.node}</React.Fragment>
          );
        }

        const hasDivider = button.key === BUTTON_KEY.EDIT;

        if (hasDivider && hasMultipleButtons) {
          return (
            <React.Fragment key={button.key}>
              <Divider type="vertical" className={styles.buttonDivider} />
              {renderButton(button)}
            </React.Fragment>
          );
        }

        return renderButton(button);
      })}
    </div>
  );
};
